/* eslint-disable class-methods-use-this */

import { Controller } from 'stimulus';
import jump from 'jump.js';
import delegatedEventListener from '../helpers/delegatedEventListener';

class InternalLinks extends Controller {
  connect() {
    delegatedEventListener('click', 'a[href^="#"]', window, (event) => {
      const href = event.target.getAttribute('href');

      if (href === '#') {
        return true;
      }

      const target = document.querySelector(href);

      if (!target) {
        return true;
      }

      event.preventDefault();

      jump(target, {
        offset: -80,
      });

      return false;
    });
  }
}

export default InternalLinks;
